import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}
interface GetSavedRoleInfoRes extends commomRes {
  data: {
    has_saved_role_info: boolean;
    get_saved_role_info: RoleInfo;
    vote_log_list: {
      num: number;
      tag_id: string;
      timestamp: number;
    }
  };
}

export interface Vote {
  num: number;
  tag_id: string
}
interface GetPageVoteNumber extends commomRes {
  data: {
    vote_list: {
      team_list: Vote[]
    }
  };
}
const lang_type = getLang();
// @see https://yapi.intlgame.com/project/1344/interface/api/81841
export const getSavedRoleInfo = async () => {
  const otherurl = 'api/flow/Wand-20230614113546-F56bb07a49bf3';
  const htmlurl = 'api/flow/Wand-20230626032854-F5413dea19333';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetSavedRoleInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    get_role_info: RoleInfo;
  };
}

interface VoteParams {
  tag_id: string;
};
// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20230614113508-Faf87742ad954';
  const htmlurl = 'api/flow/Wand-20230626032929-F3591f1cd0ab2';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20230614113529-F89041b7bb97e';
  const htmlurl = 'api/flow/Wand-20230626032923-Fd68ccb1f8995';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};

export const getVoteNumber = async () => {
  const otherurl = 'api/flow_direct/Wand-20230615121813-F26a8b92266d6';
  const htmlurl = 'api/flow_direct/Wand-20230620020705-Fb0bed4c4fafa';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetPageVoteNumber>(`${origin}${url}`,  {
      checkLogin: false,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};

export const roleVote = async (params: VoteParams) => {
  const otherurl = 'api/flow/Wand-20230615121850-Fe934864cab65';
  const htmlurl = 'api/flow/Wand-20230620020705-F92ef2aa35fcf';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params
    })
    .then((res) => res.data);
};

interface  JoinTeamRes extends commomRes{
  data: {
    join_success: boolean;
  }
}
export const joinTeam = async () => {
  const otherurl = 'api/flow/Wand-20230615123300-F3e9a9d09a0d5';
  const htmlurl = 'api/flow/Wand-20230626032848-Fb6dcc496a172';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<JoinTeamRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};